//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_sceneModeColumbusView = 1.0;\n\
";
